const columns = () => ([
  {
    title: 'Postal code',
    dataIndex: 'zip',
    key: 'zip',
  },
  {
    title: 'Local pick up zone',
    dataIndex: 'localPickUp',
    key: 'localPickUp',
  },
  {
    title: 'Delete',
    dataIndex: 'delete',
    key: 'delete',
  },
]);

export default columns;
